import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable({
  providedIn: 'root',
})
export class SpinnerService {
  showSpinner = false;

  constructor(private readonly  service: NgxSpinnerService) {}

  open() {
    setTimeout(() => {
      !this.showSpinner && this.service.show();
      this.showSpinner = true;
    });
  }

  close() {
    setTimeout(() => {
      this.showSpinner = false;
      this.service.hide();
    });
  }

  reset() {
    this.showSpinner = false;
    this.service.hide();
  }
}
